import React from "react";
import "./About.css";
const Banner = (props) => {
  return (
    <div>
      <div className="about_imagesection">
        <div className="about_image">
          <img src={props.imgURL} alt={props.title} />
        </div>
      </div>
    </div>
  );
};

export default Banner;
